import React, { useState } from 'react';
import { useLang } from '../hooks/useLang';

const EarlyAccessBanner = ({ region, pac_amount, onHide }) => {
  const { t, lang } = useLang();
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email || isSubmitting) return;
    
    setIsSubmitting(true);
    
    try {
      const apiUrl = process.env.REACT_APP_API_URL || 'https://centeo-backend.onrender.com';
      
      const response = await fetch(`${apiUrl}/api/early-access`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email.trim(),
          region: region || null,
          pac_amount: pac_amount || null,
          language: lang
        }),
      });

      const result = await response.json();
      console.log('API Response:', result);
      
      if (result.success) {
        setIsSubmitted(true);
        setEmail('');
        
        // Toast-ähnliche Benachrichtigung
        const toast = document.createElement('div');
        toast.className = 'fixed top-4 right-4 bg-green-500 text-white px-6 py-3 rounded-lg shadow-lg z-50 font-medium';
        toast.textContent = t('earlyAccess.thankYou') || 'Vielen Dank – Bestätigungsmail wurde versendet!';
        document.body.appendChild(toast);
        
        setTimeout(() => {
          if (document.body.contains(toast)) {
            document.body.removeChild(toast);
          }
        }, 5000);
        
        // Reset nach 10 Sekunden für weitere Anmeldungen
        setTimeout(() => {
          setIsSubmitted(false);
        }, 10000);
      } else {
        alert(t('earlyAccess.error') || 'Fehler bei der Anmeldung. Bitte versuchen Sie es erneut.');
      }
    } catch (error) {
      console.error('Early Access submission error:', error);
      console.error('Error details:', error.message);
      console.error('API URL:', process.env.REACT_APP_API_URL || 'https://centeo-backend.onrender.com');
      alert(`Fehler: ${error.message}. Bitte versuchen Sie es erneut oder kontaktieren Sie uns.`);
    } finally {
      setIsSubmitting(false);
    }
  };

  // Banner nicht mehr automatisch ausblenden
  // Force deployment trigger

  return (
    <section className="bg-gradient-to-r from-lime-50 to-green-50 border-l-4 border-lime-400 p-6 my-8 rounded-lg shadow-sm">
      <div className="max-w-4xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
          <div className="flex-1">
            <h3 className="text-lg sm:text-xl font-bold text-lime-800 mb-3 flex items-center gap-2">
              🚜 {t('earlyAccess.title') || 'Bald verfügbar: Vorfinanzierung eurer EU-Agrarförderung'}
            </h3>
            <p className="text-sm sm:text-base text-lime-700 leading-relaxed mb-4 lg:mb-0">
              {t('earlyAccess.subtitle') || 'Wir arbeiten an einer innovativen Lösung, mit der ihr eure Förderansprüche schon vor der Auszahlung liquid machen könnt. Seid unter den Ersten, die davon profitieren!'}
            </p>
            {isSubmitted && (
              <div className="mt-3 p-3 bg-green-100 border border-green-300 rounded-md">
                <p className="text-green-800 text-sm font-medium flex items-center gap-2">
                  ✅ {t('earlyAccess.success') || 'Erfolgreich angemeldet! Bestätigungsmail wurde versendet.'}
                </p>
              </div>
            )}
          </div>
          
          <div className="flex-shrink-0">
            <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3">
              <input
                type="email"
                placeholder={t('earlyAccess.emailPlaceholder') || 'Ihre E-Mail-Adresse'}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={isSubmitting}
                className="text-base border-2 border-lime-300 rounded-lg px-4 py-3 w-full sm:w-64 focus:outline-none focus:ring-2 focus:ring-lime-500 focus:border-lime-500 disabled:opacity-50 transition-all"
              />
              <button
                type="submit"
                disabled={isSubmitting || !email}
                className="bg-lime-600 text-white text-base font-medium rounded-lg px-6 py-3 hover:bg-lime-700 disabled:opacity-50 disabled:cursor-not-allowed transition-all transform hover:scale-105 whitespace-nowrap"
              >
                {isSubmitting 
                  ? (t('earlyAccess.submitting') || 'Wird gesendet...') 
                  : (t('earlyAccess.button') || 'Jetzt informieren')
                }
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EarlyAccessBanner;